import styled from '@emotion/styled';
import { X } from 'react-feather';

export const ChipList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: var(--gray-xl, #f5f5f5);
  border: 1px solid var(--sec-01, #e0e0e0);
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 13px;
  font-family: var(--font-reg);
  line-height: 1.4;
  color: var(--black, #333);
`;

export const ChipRemoveButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: var(--gray-d, #999);
  border-radius: 2px;
  transition: color 0.15s ease;

  &:hover {
    color: var(--pri-02, #d32f2f);
  }
`;

type ChipRemoveProps = {
  onClick: () => void;
};

export const ChipRemove = ({ onClick }: ChipRemoveProps) => (
  <ChipRemoveButton onClick={onClick} type="button" title="Remove">
    <X size={12} />
  </ChipRemoveButton>
);
